import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18next'

import { jsonToQueryString } from '@/utils'
import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'

import {
  setSnackbarAction,
  setLoadingFullAction,
} from '@/state/ui/global/slices/index.slices'
import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'

import {
  GetBonusesPayload,
  BonusesResponse,
  BonusEngineState,
  Bonus,
} from '../models'
import { BonusEngineActions } from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllBonusesThunk = createAsyncThunk(
  ActionTypes.GET_ALL_BONUSES,
  async (payload: GetBonusesPayload | any, thunkAPI) => {
    try {
      const { xlsx, ...queries } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(BonusEngineActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      let queryData
      if (queries.triggerBy !== undefined && queries.triggerBy === '-1') {
        const { triggerBy, ...rest } = queries
        queryData = `${jsonToQueryString(rest)}&triggersBy=1&triggersBy=2`
      } else {
        queryData = jsonToQueryString(queries)
      }

      restApiService.requestParams = {
        method: 'GET',
        endpoint: BONUS_PROGRAMS.FIND_ALL,
        queries: queryData,
      }

      const response: BonusesResponse = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getAllBonusesExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(getAllBonusesThunk.fulfilled, (state, { payload, meta }) => {
    const { xlsx } = meta?.arg
    state.isLoading = false
    state.bonuses = xlsx ? state.bonuses : payload.docs || []
    state.pagination = xlsx
      ? state.pagination
      : {
          ...state.pagination,
          total: payload.total,
          pages: payload.pages,
          page: payload.page,
          limit: payload.limit,
        }
    state.bonusNames =
      payload.docs &&
      payload.docs.map((bonus: Bonus) => {
        return {
          code: bonus.code || '',
          name: bonus.name || '',
        }
      })
  })
}

export default getAllBonusesExtraReducer
